module.exports = __webpack_public_path__ + "img/barclays-logo.dcf84e57.png";